import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { PerfilPipe } from 'src/app/shared/pipes/perfil.pipe'
import { Perfil } from '../perfil'
import { RegistroAcademicoSelecionarComponent } from '../registro-academico-selecionar/registro-academico-selecionar.component'
import { BehaviorSubject, Subscription } from 'rxjs'
import { MenuService } from '../menu.service'

@Component({
  selector: 'app-perfil-selecionar',
  templateUrl: './perfil-selecionar.component.html',
  styleUrls: ['./perfil-selecionar.component.css'],
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    PerfilPipe,
    RegistroAcademicoSelecionarComponent,
  ],
})
export class PerfilSelecionarComponent implements OnInit, OnDestroy {
  nome: string = ''
  private perfisSubscription!: Subscription
  perfis$ = new BehaviorSubject<Perfil[]>([])
  perfis: Perfil[] = []

  perfisNaoLiberado: string[] = ['AREX', 'CCD', 'CONSULTA_DISCENTE', 'DOCENTE', 'DTA']
  alertaPerfis: boolean = false

  constructor(private menuService: MenuService) {}

  ngOnInit(): void {
    this.nome = this.menuService.getNomeUsuario()
    this.perfisSubscription = this.menuService.perfis$.subscribe(value => {
      this.alertaPerfis = this.alertarPerfilBloqueado(value)
      this.perfis = value
      this.perfis$.next(this.perfis)
    })
  }

  changeSelecao(perfil: Perfil): void {
    this.setSelecao(perfil)
  }

  private setSelecao(perfil: Perfil): void {
    this.menuService.loadMenuPorPerfil(perfil)
  }

  ngOnDestroy() {
    if (this.perfisSubscription) {
      this.perfisSubscription.unsubscribe()
    }
  }

  private alertarPerfilBloqueado(p: Perfil[]) {
    for (let i = 0; i < p.length; i++) {
      if (this.perfisNaoLiberado.includes(p[i].nome)) {
        return true
      }
    }
    return false
  }
}
